import InstanceApi from "@/services/apiClient.js";
import EventBus from "@/event-bus";
import { mapGetters, mapActions } from "vuex";
import ModalConfirm from "@/components/Modal/ModalConfirm.vue";

export default {
  computed: {
    ...mapGetters({
      productId: "getProductId",
      productName: "getProductName",
      preprendCartData: "getPreprendCartData",
      taxProfile: "getTaxProfile",
      currentTva: "getProductTVAForCurrentDelivery",
      selectedDeliveryDateStart: "getDeliverySelectedDateStart",
      currentCartDelivery: "getCurrentCartDelivery",
      selectedDeliveryId: "getDeliverySelectedId",
      currentDeliveryId: "getDeliveryCurrentId",
      needCartCleaning: "getPreprendCartNeedCartCleaning",
      installationProductInCart: "getPreprendCartInstallationProductInCart",
      standardDeliveryInCart: "getPreprendCartStandardDeliveryInCart",
      deliveryOnly: "getPreprendCartDeliveryOnly",
      isExclusive: "getPreprendCartIsExclusive",
      currentSelectedDelivery: "getPreprendCartCurrentSelectedDelivery",
      checkoutUrl: "getCurrentCartCheckoutUrl",
      productEssentialsOptions: "getCurrentCartAdditionalOptions",
      isZeborne: "isZeborne",
      isLead: "isLead",
      storeUrlPrefix: "getStoreUrlPrefix",
      cartUrl: "getProductCartUrl",
      productUniverse: "getProductUniverse"
    }),
  },

  data() {
    return {
      showModalConfirm: false,
      modalContentConfirm: "",
      showModal: false,
      needsApproval: true,
      needCartCleaningData: false,
      installationProductInCartData: false,
      standardDeliveryInCartData: false,
      deliveryOnlyData: false,
      autoRedirect: true,
    };
  },

  components: {
    ModalConfirm,
  },

  created() {
    EventBus.$on("submit-form", () => this.addProductToCart());
    EventBus.$on("add-to-cart-noRedirect", () => {
      this.autoRedirect = false;
      this.addProductToCart()
    });
  },

  mounted() {
    this.needCartCleaningData = this.needCartCleaning;
    this.installationProductInCartData = this.installationProductInCart;
    this.standardDeliveryInCartData = this.standardDeliveryInCart;
    this.deliveryOnlyData = this.deliveryOnly;
    this.isExclusiveData = this.isExclusive;
  },

  watch: {
    needCartCleaning() {
      this.needCartCleaningData = this.needCartCleaning;
    },
    installationProductInCart() {
      this.installationProductInCartData = this.installationProductInCart;
    },
    standardDeliveryInCart() {
      this.standardDeliveryInCartData = this.standardDeliveryInCart;
    },
    deliveryOnly() {
      this.deliveryOnlyData = this.deliveryOnly;
    },
    isExclusive() {
      this.isExclusiveData = this.isExclusive;
    },
  },

  methods: {
    ...mapActions([
      "updateCurrentCartRecaps",
      "setPreprendCartNeedCartCleaning",
      "setPreprendCartStandardDeliveryInCart",
      "setPreprendCartInstallationProductInCart",
      "setCurrentUserIsLoggedIn",
      "setCurrentUser",
    ]),

    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },

    openModalConfirm(content) {
      this.modalContentConfirm = content;
      this.showModalConfirm = true;
    },

    closeModalConfirm() {
      this.showModalConfirm = false;
    },

    verrifyConsents() {
      if (this.standardDeliveryInCartData && this.deliveryOnlyData === 0) {
        this.needsApproval = true;
        return this.openModalConfirm(
          "<div class='ModalInfo-ComfirmText'><p>Vos articles dans le panier sont en livraison seule.<br>En ajoutant un article en livraison et installation, les articles présents dans votre panier seront supprimés.<br>Pour ajouter d'autres articles en livraison seule, cochez sur livraison seule, au dessus du prix.<br><br>Souhaitez-vous continuer ?</p></div>",
        );
      }
      if (this.installationProductInCartData && this.deliveryOnlyData === 1) {
        this.needsApproval = true;
        return this.openModalConfirm(
          "<div class='ModalInfo-ComfirmText'><p>Vos articles dans le panier sont avec installation.<br>En ajoutant un article en livraison seule, les articles présents dans votre panier seront supprimés.<br>Vous ne pourrez plus bénéficier de la TVA à taux réduit.<br><br>Souhaitez-vous continuer ?</p></div>",
        );
      }

      if (this.needCartCleaningData === true) {
        this.needsApproval = true;
        return this.openModalConfirm(
          "<div class='ModalInfo-ComfirmText'><p>Votre panier contient déjà un produit. Souhaitez vous le remplacer par celui ci : " +
            this.productName +
            " ?</p></div>",
        );
      }

      return this.updateConsents();
    },

    updateConsents() {
      this.needsApproval = false;
      if (this.isExclusiveData) {
        this.setPreprendCartNeedCartCleaning(true);
      }

      if (this.deliveryOnlyData === 1) {
        this.setPreprendCartInstallationProductInCart(false);
        this.setPreprendCartStandardDeliveryInCart(true);
      } else {
        this.setPreprendCartInstallationProductInCart(true);
        this.setPreprendCartStandardDeliveryInCart(false);
      }

      this.closeModalConfirm();
      this.addProductToCart();
    },

    async addProductToCart() {
      
      let productEssentialsOptionsParams = [];
      let apiUrlAddToCart;
      
      if(this.isZeborne) {
        apiUrlAddToCart = "mcp/mibcart/add/product/";
      } else {
        apiUrlAddToCart = "mcp/cart/add";
      }

      if (this.isExclusiveData === false && typeof this.currentCartDelivery.type !== "undefined") {
        if (this.currentCartDelivery.type !== this.currentSelectedDelivery) {
          this.setPreprendCartNeedCartCleaning(true);
        }
      }

      // Ask consents to change product in cart.
      if (this.needsApproval === true) {
          return this.verrifyConsents();
      }
      if (
        this.preprendCartData.mcp_intervention_slot !== "" &&
        this.selectedDeliveryDateStart !== "" &&
        this.selectedDeliveryId === this.currentDeliveryId
      ) {


        // ADD PREPEND DATA KEY
        Object.keys(this.preprendCartData).forEach(key => {
          if (this.preprendCartData[key] !== "") {
            apiUrlAddToCart = apiUrlAddToCart + "/" + key + "/" + this.preprendCartData[key];
          }
        });

        // ADD TAX PROFILE
        Object.keys(this.taxProfile[this.currentTva]).forEach(key => {
          if (this.taxProfile[this.currentTva][key] !== "") {
            apiUrlAddToCart =
              apiUrlAddToCart + "/" + key + "/" + this.taxProfile[this.currentTva][key];
          }
        });

        if(this.productEssentialsOptions.length > 0) {
          this.productEssentialsOptions.forEach(function (item, index, array) {
              productEssentialsOptionsParams.push(item.productId);
          });
          apiUrlAddToCart += "/essentials_options/"+productEssentialsOptionsParams.join(',');
          apiUrlAddToCart += "/keep_options/true";
        }

        // Fill input fields with gclid & fbclid data, addFbclid & addGclid are functions within scripts injected by GoogleTagManager
        if (typeof window.addFbclid === "function") { 
          window.addFbclid();
          let fbclidInput = document.querySelector('#fbclid_field');
          let fbclidValue = fbclidInput ? fbclidInput.value : '';
          apiUrlAddToCart += "/mcp_fbclid/"+fbclidValue;
        }

        if (typeof window.addGclid === "function") { 
          window.addGclid();
          let gclidInput = document.querySelector('#gclid_field');
          let gclidValue = gclidInput ? gclidInput.value : '';
          apiUrlAddToCart += "/mcp_gclid/"+gclidValue;
        }

        try {
          if(!this.isLead){
            EventBus.$emit("loadProductSpinner");
            
            /**
             * Gtm event push
             * @param gtmDataFormat data formated type in gtm.js
             */
            let gtmDataFormat = "product"
            if(window.McpGtm) McpGtm.pushCustomDataLayer('order', {}, {}, gtmDataFormat);
          }    
          
          const response = await InstanceApi.get(apiUrlAddToCart);
          this.updateCurrentCartRecaps(response.data);
          this.needsApproval = true ;
          this.needCartCleaningData = false;

          if (response.data.customer_logged_in) {
            this.setCurrentUserIsLoggedIn(response.data.customer_logged_in);
            this.setCurrentUser(response.data.customer);
          }
          

          //Display popin "product added to Cart"
          if(
            this.productUniverse.toLowerCase().includes('sèche-serviette')  || 
            this.productUniverse.toLowerCase().includes('radiateur')
          ) {
            EventBus.$emit("loadProductSpinner");
            EventBus.$emit("open-modal-addedCart")
            this.autoRedirect = false;
            
          }

          if(this.autoRedirect){
            window.location = process.env.VUE_APP_API_BASE_URL + this.storeUrlPrefix + this.cartUrl;
          } 

        } catch (error) {
          EventBus.$emit("loadProductSpinner");
          this.$fire({
            title: "Oups",
            text: "Une erreur s'est produite lors de l'ajout du produit au panier",
            type: "error",
            position: "top-end",
            showConfirmButton: true,
          });
        }
      } else {
        EventBus.$emit("display-dates-messages");
      }
    },
  },
};